import React from 'react';
import {
    FaBuilding,
    FaStore,
    FaLandmark,
    FaGavel,
    FaShieldHalved,
    FaHandHoldingHeart,
    FaUsers,
    FaStar,
    FaPersonRunning,
    FaUser,
} from 'react-icons/fa6';

// Mirrors api/src/models/enums/entity-type.enum.ts — kept in sync by hand since the
// admin/app/api projects don't share a package.
export enum EntityType {
    CORPORATION = 'corporation',
    SMALL_BUSINESS = 'small_business',
    GOVERNMENT = 'government',
    POLITICIAN = 'politician',
    LAW_ENFORCEMENT = 'law_enforcement',
    NONPROFIT = 'nonprofit',
    ORGANIZATION = 'organization',
    CELEBRITY = 'celebrity',
    ATHLETE = 'athlete',
    CIVILIAN = 'civilian',
}

interface EntityTypeStyle {
    label: string;
    icon: React.ComponentType<{ size?: number; className?: string }>;
    accent: string; // tailwind gradient classes for the profile header glow (dark theme)
    badge: string; // tailwind classes for the type badge
}

export const ENTITY_TYPE_STYLES: Record<string, EntityTypeStyle> = {
    corporation: { label: 'Corporation', icon: FaBuilding, accent: 'from-slate-500/25 via-slate-900/10 to-transparent', badge: 'border-slate-400/30 bg-slate-400/10 text-slate-200' },
    small_business: { label: 'Small Business', icon: FaStore, accent: 'from-amber-500/25 via-amber-900/10 to-transparent', badge: 'border-amber-400/30 bg-amber-400/10 text-amber-200' },
    government: { label: 'Government', icon: FaLandmark, accent: 'from-blue-500/25 via-blue-900/10 to-transparent', badge: 'border-blue-400/30 bg-blue-400/10 text-blue-200' },
    politician: { label: 'Politician', icon: FaGavel, accent: 'from-indigo-500/25 via-indigo-900/10 to-transparent', badge: 'border-indigo-400/30 bg-indigo-400/10 text-indigo-200' },
    law_enforcement: { label: 'Law Enforcement', icon: FaShieldHalved, accent: 'from-cyan-500/25 via-cyan-900/10 to-transparent', badge: 'border-cyan-400/30 bg-cyan-400/10 text-cyan-200' },
    nonprofit: { label: 'Nonprofit', icon: FaHandHoldingHeart, accent: 'from-emerald-500/25 via-emerald-900/10 to-transparent', badge: 'border-emerald-400/30 bg-emerald-400/10 text-emerald-200' },
    organization: { label: 'Organization', icon: FaUsers, accent: 'from-purple-500/25 via-purple-900/10 to-transparent', badge: 'border-purple-400/30 bg-purple-400/10 text-purple-200' },
    celebrity: { label: 'Celebrity', icon: FaStar, accent: 'from-pink-500/25 via-pink-900/10 to-transparent', badge: 'border-pink-400/30 bg-pink-400/10 text-pink-200' },
    athlete: { label: 'Athlete', icon: FaPersonRunning, accent: 'from-orange-500/25 via-orange-900/10 to-transparent', badge: 'border-orange-400/30 bg-orange-400/10 text-orange-200' },
    civilian: { label: 'Civilian', icon: FaUser, accent: 'from-zinc-500/25 via-zinc-900/10 to-transparent', badge: 'border-zinc-400/30 bg-zinc-400/10 text-zinc-200' },
};

export const getEntityTypeStyle = (type: string): EntityTypeStyle =>
    ENTITY_TYPE_STYLES[type] || ENTITY_TYPE_STYLES.civilian;
